import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PlannerNotices } from '../components/PlannerNotices.js';

export const Route = createFileRoute('/_planner')({
  component: PlannerLayout,
});

function PlannerLayout() {
  return (
    <>
      <PlannerNotices />
      <Outlet />
    </>
  );
}
